import { createElement } from 'react';
import { TableHeaderSelectAllButton } from '@/components/table-selection/TableSelectionHeaderControls';
import type { TableProps } from '@/ui/Table';

export const buildGroupTableBindings = <TData>({
    columns,
    data,
    rowKey,
    tableId,
    tableScope,
    onSortChanged,
    currentSort,
    pickedData,
    onAllPicked,
    onHeaderCheckboxChange,
    onCheckboxChange,
    isHeaderChecked,
    checkboxData,
    headerSecondaryRow,
    onRowClick,
}: {
    columns: TableProps<TData>['columns'];
    data: TData[];
    rowKey?: TableProps<TData>['rowKey'];
    tableId?: TableProps<TData>['tableId'];
    tableScope?: TableProps<TData>['tableScope'];
    onSortChanged: NonNullable<TableProps<TData>['onSortChanged']>;
    currentSort: NonNullable<TableProps<TData>['currentSort']>;
    pickedData: string[];
    onAllPicked: () => Promise<void>;
    onHeaderCheckboxChange: NonNullable<TableProps<TData>['onHeaderCheckboxChange']>;
    onCheckboxChange: NonNullable<TableProps<TData>['onCheckboxChange']>;
    isHeaderChecked: boolean;
    checkboxData: NonNullable<TableProps<TData>['checkboxData']>;
    headerSecondaryRow: TableProps<TData>['headerSecondaryRow'];
    onRowClick: NonNullable<TableProps<TData>['onRowClick']>;
}) => ({
    columns,
    data,
    rowKey,
    tableId,
    tableScope,
    onSortChanged,
    currentSort,
    pickedData,
    headerSelectionContent: createElement(TableHeaderSelectAllButton, {
        selectedItemsCount: pickedData.length,
        onAllPicked,
    }),
    showHeaderCheckbox: false,
    onHeaderCheckboxChange,
    onCheckboxChange,
    isHeaderChecked,
    checkboxData,
    headerSecondaryRow,
    onRowClick,
});
